import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  courseData: null,
  getCourseData: action(function(installSid, courseSid, backgroundLoad) {
    if(!backgroundLoad) {
      SessionStore.startLoading('Loading…', 'getCourseData');
    } else {
      SessionStore.startBackgroundLoading('getCourseData');
    }

    api.get(`/installs/${installSid}/courses/${courseSid}`)
      .then(response => {
        obx.courseData = response.data;

        if(!backgroundLoad) {
          SessionStore.finishLoading('getCourseData');
        } else {
          SessionStore.finishBackgroundLoading('getCourseData');
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get roster
  courseRoster: [],
  getCourseRoster: action(function(roles, installSid, courseSid, backgroundLoad) {
    if(!backgroundLoad) {
      SessionStore.startLoading('Loading…', 'CourseRoster');
    } else {
      SessionStore.startBackgroundLoading('CourseRoster');
    }

    obx.courseRoster = [];

    if(roles) {
      let roleData = '';

      if(roles.constructor === Array) {

        for(let i = 0; i < roles.length; i++) {
          if(i === 0) {
            roleData += roles[i];
          } else {
            roleData += `&roles=${roles[i]}`
          }
        }
      } else {
        roleData = roles;
      }

      if(typeof installSid === 'undefined') {
        installSid = SessionStore.userData.installSid;
      }

      if(typeof courseSid === 'undefined') {
        courseSid = SessionStore.userData.courseSid;
      }

      api.get(`/installs/${installSid}/courses/${courseSid}/enrollments?roles=${roleData}`)
        .then(response => {
          obx.courseRoster = response.data.results;

          if(!backgroundLoad) {
            SessionStore.finishLoading('CourseRoster');
          } else {
            SessionStore.finishBackgroundLoading('CourseRoster');
          }
        })
        .catch(error => {
          SessionStore.throwError(error);
        });
    } else {
      api.get(`/installs/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}/enrollments`)
        .then(response => {
          obx.courseRoster = response.data.results;
          SessionStore.finishLoading('CourseRoster');
        })
        .catch(error => {
          SessionStore.throwError(error);
        });
    }
  }),
  // Get Proctor Users
  proctorUsers: [],
  proctorUser: null,
  listProctorUsers: action(function(userSid) {
    SessionStore.startLoading('Loading…', 'listProctorUsers');
    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}/users`)
        .then(response => {
          obx.proctorUsers = response.data.results;
          if(userSid){
            response.data.results.some(user => {
              if (user.sid === userSid) {
                obx.proctorUser = user;
                return true;
              }
              return false;
            });
          }
          SessionStore.finishLoading('listProctorUsers');
        })
        .catch(error => {
          SessionStore.throwError(error);
        });
  }),

  // Edit Proctor User
  updateProctorUser: action(function(data, callback) {
    SessionStore.startLoading('Loading…', 'editProctorUsers');
    api.patch(`proctors/${SessionStore.userData.proctorAccountSid}/users/${obx.proctorUser.sid}`, data)
    .then(response => {
      obx.courseRoster = response.data.results;
      SessionStore.finishLoading('editProctorUsers');

      if(callback) {
        callback();
      }

    })
    .catch(error => {
      SessionStore.throwError(error);
    });
  }),

  // Create New Proctor User
  newProctorUser: action(function(data,callback) {
    SessionStore.startLoading('Loading…', 'createProctorUser');
    api.post(`/proctors/${SessionStore.userData.proctorAccountSid}/users/create`, data)
    .then(response => {
      obx.courseRoster = response.data.results;
      SessionStore.finishLoading('editProctorUsers');

      if(callback) {
        callback();
      }

    })
    .catch(error => {
      SessionStore.throwError(error);
    });
  }),

  // Delete Proctor User
  deleteProctorUser: action(function(callback) {
    SessionStore.startLoading('Loading…', 'deleteProctorAccountUser');
    api.delete(`/proctors/${SessionStore.userData.proctorAccountSid}/users/${obx.proctorUser.sid}`)
    .then(response => {
      obx.courseRoster = response.data.results;
      SessionStore.finishLoading('deleteProctorAccountUser');

      if(callback) {
        callback();
      }

    })
    .catch(error => {
      SessionStore.throwError(error);
    });
  })
  });

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/EnrollmentStore.js